import {Canton, Commune, Domaine, Pays, Prefecture, Region, Specialite, TypeDiplome, TypePiece} from '../../parametre/parametre.model';
import {Fichier, User} from '../../securite/auth.model';
import {Candidature} from '../../candidature/models/candidature.model';

export class Candidat {
    id: number
    nom: string
    prenoms: string
    commentaire?: string
    comment_user_id?: number
    motivation: string
    sexe: string
    id_cv_file: number
    id_piece_id_file: number

    url_cv: string
    url_piece_id: string
    num_piece: string
    etat?: string
    id_type_piece: string
    date_naissance: string
    telMobile1: string
    telMobile2: string
    lieu_naissance: string
    id_specialite: string
    id_prefecture_naissance: string
    idPrefectureOrigine: string
    idRegionResidence: string
    idPrefectureResidence: string
    idCommuneResidence: string
    idCantonResidence: string
    lieu_residence: string
    id_nationalite: string
    id_pays_naissance: string
    id_pays_residence: string
    id_candidat_core?: string
    situation_matrimoniale: string
    handicape: boolean
    profil_is_valide?: boolean
    adresse: string
    boite_postal: string
    user_id: number
    created_at: string
    updated_at: string
    typePiece: TypePiece
    specialite: Specialite
    prefectureNaissance: Prefecture
    prefectureOrigine: Prefecture
    paysNaissance: Pays
    paysResidence: Pays
    regionResidence: Region
    prefectureResidence: Prefecture
    communeResidence: Commune
    cantonResidence: Canton
    cand_notif: CandNotif
    contacts?: ContactCandidat[]
    formations: Formation[]
    experiences: Experience[]
    user?: User;
    candidature?: Candidature;
}
export class CandNotif {
    id: number
    telephone_fixe: string
    email: string
    candidat_id: number
    created_at: string
    updated_at: string
}
export class ContactCandidat {
    id?: number
    nom: string
    prenoms: string
    sexe: string
    email: string
    telMobile: string
    lieuResidence: string
    ligneAdresse: string
    candidat_id?: number
    created_at?: string
    updated_at?: string
}

export class Formation {
    id: number
    titre: string
    etablissement: string
    idPays: number
    pays: Pays
    idDomaine: number
    idSpecialite: number
    domaine: Domaine
    specialite: Specialite
    idTypeDiplome: number
    typeDiplome: TypeDiplome
    idDiplomeFile: string

    diplomeFile: Fichier
    dateDebut: string
    dateFin: string
    candidat_id?: number
    created_at?: string
    updated_at?: string
}

export class Experience {
    id: number
    posteOccupe: string
    nomStructure: string
    nomReference: string
    emailReference: string
    telMobileReference: string
    idSpecialite: number
    specialite: Specialite
    idDomaine: number
    domaine: Domaine
    idPays: number
    pays: Pays
    description: string
    dateDebut: string
    dateFin: string
    candidat_id?: number
    created_at?: string
    updated_at?: string
}



